import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";
import { getIdioma } from "../../utils/variablesLocales";

export function initialValues() {
  return {
    idioma: getIdioma(),
  };
}

export function validationSchema() {
  return Yup.object({
    idioma: Yup.string().required(` ${campo_obligatorio} `),
  });
}
